import Property from './PropertyInteger';

export default Property.extend({
  defaults: {
    ...Property.prototype.defaults,
    showInput: 1
  }
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/style_manager/model/PropertySlider.js